import { Flex, Table } from 'antd'
import React, { useState, useEffect } from 'react'
import { useJKspjdListQuery } from '../../../store/DianShangYeWuApi'
import RuleLoanAdd from './RuleLoanAdd'
import RuleLoanEdit from './RuleLoanEdit'
import RuleLoanCopy from './RuleLoanCopy'
function RuleLoanList(props) {
    const [list, setList] = useState([])
    const {data, isSuccess} = useJKspjdListQuery({jk_spjd_qy_id:props.qy_id});
    useEffect(() => {
        if(isSuccess && data.Status === 'success' && data.Result){
            setList(data.Result)
        }else{
            setList([])
        }
    }, [data, isSuccess])
    const columns = [
        {
            title: '操作',
            dataIndex: 'jk_spjd_id',
            key: 'jk_spjd_id',
            render: (text, record) => <RuleLoanCopy 
                                        jk_spjd_id={record.jk_spjd_id} 
                                        useList={props.useList} 
                                        deptList={props.deptList} 
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                    />,
        },
        {
            title: '借款单规则名称',
            dataIndex: 'jk_spjd_content',
            key: 'jk_spjd_content',
            render: (text, record) => <RuleLoanEdit 
                                        jk_spjd_content={text} 
                                        jk_spjd_id={record.jk_spjd_id} 
                                        useList={props.useList} 
                                        deptList={props.deptList} 
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                    />,
        },
        {
            title: '借款单部门',
            dataIndex: 'jk_spjd_bm_name',
            key: 'jk_spjd_bm_name',
        },     
        {
            title: '借款单最小金额',
            dataIndex: 'jk_spjd_amount_min',
            key: 'jk_spjd_amount_min',
        },
        {
            title: '借款单最大金额',
            dataIndex: 'jk_spjd_amount_max',
            key: 'jk_spjd_amount_max',
        },
        {
            title: '新增记录',
            dataIndex: 'jk_spjd_uname',
            key: 'jk_spjd_uname',
            render: (text, record) => <span>{record.jk_spjd_uname} {record.jk_spjd_ctime}</span>,
        }
       
    ]
    return (
        <>
            <Flex
                justify='space-between'
                align='center'
               
            >       
               <RuleLoanAdd 
                    qy_id={props.qy_id}
                    qy_name={props.qy_name}
                    yh_id={props.yh_id}
                    yh_name={props.yh_name}
                    useList={props.useList}
                    deptList={props.deptList}
               />
            </Flex>
            <Table
                columns={columns}
                dataSource={list}
                pagination={false}
                rowKey='jk_spjd_id'
                size='small'
                bordered
                className="custom-table"
                style={{marginTop:'10px'}}
            />
        </>
    )
}

export default RuleLoanList